import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_CreateBookingClient = _resolveComponent("CreateBookingClient")!

  return (_ctx.isError)
    ? (_openBlock(), _createBlock(_component_ErrorMessage, {
        key: 0,
        errorType: _ctx.errorDetail,
        onTryAgain: _ctx.getDetail
      }, null, 8, ["errorType", "onTryAgain"]))
    : (_openBlock(), _createBlock(_component_CreateBookingClient, {
        key: 1,
        ref: "booking",
        onUpselling: _ctx.setProductName
      }, null, 8, ["onUpselling"]))
}